import { render } from "./Recruit.vue?vue&type=template&id=40f2dafa"
import script from "./Recruit.vue?vue&type=script&lang=js"
export * from "./Recruit.vue?vue&type=script&lang=js"

import "./Recruit.vue?vue&type=style&index=0&id=40f2dafa&lang=scss"

import exportComponent from "D:\\Wyspace\\WechatPlatForm_XINXIN\\WechatPlatForm\\Vue.EmployApply\\employVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__